import { IBookingEngineState } from "../../types";
import { stateToUrlParams } from "./stateToUrlParams";

/**
 * generateUniqueBookingSelectionHash
 * Helper to generate a unique hash for the booking selection based on the state.
 * This is useful to compare 2 hashes and determine wheter the booking selection has changed
 * and some follow up actions should be taken, e.g. when the hash stored in the checkout session
 * state doen't match the current hash then we should clear create a new checkout session
 *
 * @param state
 * @returns
 */

export const generateUniqueBookingSelectionHash = (state: IBookingEngineState): string =>
    stateToUrlParams(state, { whitelist: ["pc", "d", "br"] });
